import InputField from "components/common/controls/InputField";
import FormGroup from "components/common/FormGroup";
import PromineoPhoneInput, {
  PhoneInputValueChangedEventArg,
} from "components/common/controls/PromineoPhoneInput";
import UserResponse from "interfaces/response/UserResponse";
import PhoneDataRequest from "interfaces/request/PhoneDataRequest";

interface Props {
  user?: UserResponse;
  handleChange: (value: string, fieldName: string) => void;
  handlePhoneDataChange: (value: PhoneDataRequest) => void;
}

export default function BasicUserEditor(props: Props) {
  const { user, handleChange, handlePhoneDataChange } = props;

  const handleInputChanged = (eventArgs: any) => {
    handleChange(eventArgs.event.target.value, eventArgs.event.target.name);
  };

  const handlePhoneChanged = (event: PhoneInputValueChangedEventArg) => {
    const data: PhoneDataRequest = {
      phone: event.nationalNumber,
      phoneCode: event.countryCode,
      phoneNumberWithCode: event.number,
    };

    handlePhoneDataChange(data);
  };

  return (
    <>
      <FormGroup label="First name">
        <InputField
          placeholder="First name"
          name="firstName"
          defaultValue={user?.firstName}
          maxLength={128}
          required={true}
          id="firstName"
          label="First name"
          onChange={handleInputChanged}
        />
      </FormGroup>
      <FormGroup label="Last name">
        <InputField
          placeholder="Last name"
          name="lastName"
          defaultValue={user?.lastName}
          maxLength={127}
          required={true}
          id="lastName"
          label="Last name"
          onChange={handleInputChanged}
        />
      </FormGroup>
      <div className="col-span-2">
        <FormGroup label="Company Name">
          <InputField
            id="companyName"
            name="companyName"
            label="Company Name"
            placeholder="Company name"
            maxLength={255}
            defaultValue={user?.companyName}
            onChange={handleInputChanged}
          />
        </FormGroup>
      </div>
      <div className="col-span-2">
        <FormGroup label="Email">
          <InputField
            id="email"
            mode="email"
            label="Email"
            maxLength={255}
            placeholder="e.g. john.doe@provider.com"
            name="email"
            required={true}
            defaultValue={user?.email}
            onChange={handleInputChanged}
          />
        </FormGroup>
      </div>
      <div className="col-span-2">
        <FormGroup label="Phone (inc. country code)">
          <PromineoPhoneInput
            required
            value={user?.phone || ""}
            onPhoneNumberChanged={handlePhoneChanged}
          />
        </FormGroup>
      </div>
    </>
  );
}
